import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

export default function LoadingView(props) {
    const title = props.title || "Loading...";
  return (
    <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    flexDirection="column"
    my={4}
    >
      <CircularProgress />
      <Typography variant="body1">{title}</Typography>
    </Box>
  );
}